import { connect } from 'react-redux';
import { SubmissionError, change, untouch } from 'redux-form';
import { browserHistory } from 'react-router';
import { loadWarranty, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import validate from '../components/Validations/submitValidationsWarrantyForm'
import { getErrorsApiToReduxForm, getQueryString, sanetizeMktParams } from '../utils/utils.js';
import WarrantyForm from '../components/WarrantyForm.js';

const mapStateToProps = (state) => {

    return {
        isValidating: false,
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //For any field errors upon submission (i.e. not instant check)
        addSubscriber(values, dispatch, ownProps) {
            dispatch(submitForm());
            let errors = validate(values);
            if( Object.keys(errors).length !== 0){
                const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
                return sleep(10).then(() => {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError({ ...errors, _error: 'Revisá los campos indicados.' })
                })
            }else{
                return dispatch(loadWarranty(values)).then((result) => {
                    if (result.payload.status !== 200) {
                        dispatch(stopSubmitForm());
                        throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                    } else {
                        dispatch(getNextStep()).then((result) => {
                            if (typeof(result.payload.data.endpoint) !== 'undefined') {
                                sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                                dispatch(stopSubmitForm());
                                browserHistory.push(result.payload.data.endpoint);
                            }
                        });
                    }
                });
            }
    }
}
}

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyForm);



/** WEBPACK FOOTER **
 ** ./src/containers/WarrantyFormContainer.js
 **/